import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { fontSize } from '@constants/styles';
import CallUsButton from '../../interactive/CallUsButton';

const LandingBottomCTA = () => {
  return (
    <Box m="0px auto" textAlign="center" w="100%" py={20} bg="blue.50" px={[5, 10]}>
      <Heading fontSize={fontSize.hero} mb={5}>
        Your Medicare One-Stop-Shop
      </Heading>
      <Heading fontSize="25px" mb={5} lineHeight={1.6}>
        Your guide to Medicare Parts A & B, Medicare Advantage, and Medigap.
        <span className="add-scribble-below ">
          <Text fontSize="25px" color="blue.400" className="tracking-in-expand" ml={3}>
            100% free.
          </Text>
        </span>
      </Heading>
      <Flex alignItems="center" justifyContent="center">
        <CallUsButton />
      </Flex>
    </Box>
  );
};

export default LandingBottomCTA;
